import { Typography } from '@mui/material';

import { ColorsRaw } from '@/ui/theme/colors-raw';

export function QuizLabel({ label }: { label?: string }) {
  return (
    <Typography sx={{ fontSize: 16, color: ColorsRaw.anthracite.Anthracite_5 }}>
      {label}
    </Typography>
  );
}
